import {createRoot} from "react-dom/client";
import {AuthPage} from "../features/auth/ui/auth-page";
import {takePasswordResetToken} from "../features/auth/ui/password-reset";
import {setDocumentTitle} from "../shared/i18n";
import "../styles/main.css";

const passwordResetRoute = window.location.pathname === "/forgot-password" || window.location.pathname === "/auth/password/reset";
const phoneRecoveryRoute = window.location.pathname === "/phone-recovery";
const passwordResetToken = window.location.pathname === "/auth/password/reset" ? takePasswordResetToken() : undefined;
setDocumentTitle(phoneRecoveryRoute ? "meta.phoneRecoveryTitle" : passwordResetRoute ? "meta.passwordResetTitle" : "meta.authTitle");
const mount = document.getElementById("auth-page-root");
if (!mount) throw new Error("auth page mount is missing");
createRoot(mount).render(<AuthPage passwordResetToken={passwordResetToken} />);
